<ws-modal-wrapper [headerLabel]="masterSite ? 'Sites Linked to ' + masterSite.siteName : 'Link Sites'"
                  [cancelLabel]="(editMode) ? 'Cancel' : 'Close'"
                  [suppressKeyboardEvents]="true"
                  (save)="save()"
                  (cancel)="cancel()"
                  [disableSave]="((!masterSite) && (sites && sites.length > 1) || (sites && sites.length === 1))">
    <div class="app-ui-view ws-flex-container-vertical ws-flex-auto ws-stretch">
        @if (editMode) {
            <div class="ws-flex-none">
                <button type="button"
                        class="ace-btn btn-sm btn-primary btn-danger float-end"
                        (click)="removeAll()"
                        title="Remove all site links"
                        [disabled]="sites && !sites.length">
                    Remove All Links
                </button>
                <button type="button"
                        class="ace-btn btn-sm btn-primary float-end"
                        (click)="add()"
                        title="Add site links"
                        #focus>Add Site Links
                </button>
            </div>
        }
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)">
        </ws-ag-grid-angular>
        @if (editMode) {
            <div class="ws-flex-none ws-flex-container-vertical">
                @if ((!masterSite) && (sites && sites.length > 1)) {
                    <div class="text-danger">Master site is required.</div>
                }
                @if ((sites && sites.length === 1)) {
                    <div class="text-danger">At least 2 linked sites are required.</div>
                }
                @if (masterSite && ((!masterSite.reportingParcelId) && (!masterSite.hasActivePPParcel))) {
                    <div class="text-warning">The master site doesn't have 1 active PP parcel so the reporting parcel
                        cannot be set automatically
                    </div>
                }
            </div>
        }
    </div>
</ws-modal-wrapper>
